module.exports = __webpack_public_path__ + "ie.svg?4d307d87130980cbd6d73b2e47f5c24e";